import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CodeReviewCommentModel } from 'src/app/Models/code-review-comment-model';
import { CodeReviewTechnicalDetailsModel } from 'src/app/Models/code-review-technical-details-model';
import { CodeReviewerModel } from 'src/app/Models/code-reviewer-model';
import { TechnicalDetailsModel } from 'src/app/Models/technical-details-model';
import { CodeReviewService } from 'src/app/Services/code-review.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { SharedService } from 'src/app/Services/shared.service';

@Component({
  selector: 'ze-code-review-code-changed',
  templateUrl: './code-review-code-changed.component.html',
  styleUrls: ['./code-review-code-changed.component.scss']
})
export class CodeReviewCodeChangedComponent implements OnInit {

  reviewId: string = null;
  viewMode: "side-by-side" | "line-by-line" = "side-by-side";
  codeReviewTechinalDetailsMap: { [key: string]: CodeReviewTechnicalDetailsModel } = {};
  codeReviewTechinalDetailsData: TechnicalDetailsModel[] = [];
  technicalDetailsDataMapByTechnicalDetailsId: { [key: string]: TechnicalDetailsModel } = {};
  reviewCommentsMapByTechnicalDetailsId: { [key: string]: CodeReviewCommentModel[] } = {};
  loadingData: boolean = true;
  expandedMappingIds: Set<string> = new Set();
  commentsModification: { [key: string]: any } = {};
  currentUser: string = null;
  assignedReviewers: CodeReviewerModel[];
  isAssignedReviewer: boolean = false;

  isVisible: boolean = true;
  showDiffView :boolean = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private codeReviewService: CodeReviewService,
    private sharedService: SharedService,
    private notifyService: NotifyService,) { }

  ngOnInit() {
    this.sharedService.loaderHide.emit(true);
    this.currentUser = this.parseJwt(JSON.parse(localStorage.getItem("currentUser")).token).sub;
    this.route.parent.params.subscribe(params => {
      this.reviewId = params['reviewId'];
      this.loadData();
    });
  }

  loadData() {
    this.codeReviewService.getCodeReviewTechnicalDetailsDataByReviewId(this.reviewId).subscribe(data => {
      if(data["operationStatus"] != "ERROR") {
        this.codeReviewTechinalDetailsMap = data["data"][0];
        this.codeReviewTechinalDetailsData = data["data"][1];
        this.technicalDetailsDataMapByTechnicalDetailsId = data["data"][2];
        this.reviewCommentsMapByTechnicalDetailsId = data["data"][3];
        this.assignedReviewers = data["data"][4];
        this.isAssignedReviewer = this.assignedReviewers.some(reviewer => reviewer.name === this.currentUser);          
        this.expandedMappingIds = new Set(this.getObjectKeys(this.codeReviewTechinalDetailsMap));
        this.initializecommentsModification();
      }
      this.loadingData = false;
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.loadingData = false;
      this.sharedService.loaderHide.emit(false);
    });
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

  initializecommentsModification() {
    // Fill commentsModification with an object for each comment
    this.commentsModification = Object.keys(this.codeReviewTechinalDetailsMap).reduce((acc, key) => {
      const codeReviewComments = this.reviewCommentsMapByTechnicalDetailsId[key] || [];
      
      // For each key in the codeReviewTechinalDetailsMap, set the corresponding object
      acc[key] = {
        isAddingComment: false,
        addText: '',
        isUpdatingDeleted: false,
        comments: codeReviewComments.map((codeReviewComment) => ({
          replyText: '',
          isEditing: false,
          editText: '',
          isReplying: false,
          replies: codeReviewComment.replies.map(() => ({
            replyText: '',
            isEditing: false,
            editText: '',
            isReplying: false
          }))
        }))
      };
  
      return acc;
    }, {});
  }

  onAddComment(technicalDetailsId) {
    this.commentsModification[technicalDetailsId].isAddingComment = true;
  }

  // getSeverityClass(comment: string): string {
  //   // if (comment.includes('Severity: Critical')) return 'critical';
  //   // if (comment.includes('Severity: High')) return 'high';
  //   // if (comment.includes('Severity: Medium')) return 'medium';
  //   // if (comment.includes('Severity: Low')) return 'low';
  //   return '';
  // }

  addAiFeedback(technicalDetailsId) {
    this.sharedService.loaderHide.emit(true);
    let codeReviewCommentModel: CodeReviewCommentModel = new CodeReviewCommentModel();
    codeReviewCommentModel.body = this.technicalDetailsDataMapByTechnicalDetailsId[technicalDetailsId].data["code diff"];
    codeReviewCommentModel.technical_details_id = technicalDetailsId;
    codeReviewCommentModel.start_line = -1;
    codeReviewCommentModel.comment_line = -1;
    codeReviewCommentModel.comment_side = 'NO_SIDE';
    this.codeReviewService.addAiFeedbackByTechnicalDetailsData(codeReviewCommentModel, this.reviewId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in Adding Comment');
      } else {
        this.commentsModification[technicalDetailsId].addText = "";
        this.commentsModification[technicalDetailsId].comments.push({
          replyText: '',
          isEditing: false,
          editText: '',
          isReplying: false,
          replies: []
        });
        this.commentsModification[technicalDetailsId].isAddingComment = false;
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId].push(data["data"]);
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Adding Comment');
      this.sharedService.loaderHide.emit(false);
    });
  }

  onCommentSubmit(technicalDetailsId) {
    this.sharedService.loaderHide.emit(true);
    let codeReviewCommentModel: CodeReviewCommentModel = new CodeReviewCommentModel();
    codeReviewCommentModel.body = this.commentsModification[technicalDetailsId].addText;
    codeReviewCommentModel.technical_details_id = technicalDetailsId;
    codeReviewCommentModel.start_line = -1;
    codeReviewCommentModel.comment_line = -1;
    codeReviewCommentModel.comment_side = 'NO_SIDE';
    this.codeReviewService.addReviewCommentByCodeReviewId(codeReviewCommentModel, this.reviewId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in Adding Comment');
      } else {
        this.commentsModification[technicalDetailsId].addText = "";
        this.commentsModification[technicalDetailsId].comments.push({
          replyText: '',
          isEditing: false,
          editText: '',
          isReplying: false,
          replies: []
        });
        this.commentsModification[technicalDetailsId].isAddingComment = false;
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId].push(data["data"]);
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Adding Comment');
      this.sharedService.loaderHide.emit(false);
    });
  }

  onReviewCommentEdit(technicalDetailsId, i) {
    this.commentsModification[technicalDetailsId].comments[i].isEditing = true;
    this.commentsModification[technicalDetailsId].comments[i].editText = this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][i].body;
  }

  onReviewCommentEditCancel(technicalDetailsId, i) {
    this.commentsModification[technicalDetailsId].comments[i].isEditing = false;
    this.commentsModification[technicalDetailsId].comments[i].editText = "";
  }

  onReviewCommentEditSubmit(technicalDetailsId, index) {
    this.sharedService.loaderHide.emit(true);
    let commentId = this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id["$oid"] ? this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id["$oid"] : this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id;
    this.codeReviewService.updateCommentByCommentId(this.commentsModification[technicalDetailsId].comments[index].editText, commentId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in Updating Comment');
      } else {
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].body = this.commentsModification[technicalDetailsId].comments[index].editText;
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].comment_history.push(data["data"]);
        this.commentsModification[technicalDetailsId].comments[index].editText = '';
        this.commentsModification[technicalDetailsId].comments[index].isEditing = false;
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Updating Comment');
      this.sharedService.loaderHide.emit(false);
    });
  }

  onReviewCommentDelete(technicalDetailsId, index) {
    this.sharedService.loaderHide.emit(true);
    let deleteCommentId = this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id["$oid"] ? this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id["$oid"] : this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id;
    let deleteCodeReviewId = this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].code_review_id["$oid"] ? this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].code_review_id["$oid"] : this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].code_review_id;
    this.codeReviewService.deleteCommentByCommentId(deleteCommentId, deleteCodeReviewId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in Deleting Comment');
      } else {
        this.commentsModification[technicalDetailsId].isUpdatingDeleted = true; 
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId].splice(index, 1);
        this.commentsModification[technicalDetailsId].comments.splice(index, 1);
        this.commentsModification[technicalDetailsId].isUpdatingDeleted = false; 
        this.notifyService.notify('warning', 'Deleted', "Comment Deleted Sucessfully");
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Deleting Comment');
      this.sharedService.loaderHide.emit(false);
    });
  }

  onCommentCancel(technicalDetailsId) {
    this.commentsModification[technicalDetailsId].isAddingComment = false;
    this.commentsModification[technicalDetailsId].addText = "";
  }

  onReplyEditCancel(technicalDetailsId, i, replyIndex) {
    this.commentsModification[technicalDetailsId].comments[i].replies[replyIndex].isEditing = false;
    this.commentsModification[technicalDetailsId].comments[i].replies[replyIndex].editText = "";
  }

  onReplyEditSubmit(technicalDetailsId, index, replyIndex) {
    this.sharedService.loaderHide.emit(true);
    let commentId = this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].replies[replyIndex]["$oid"] ? this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].replies[replyIndex]["$oid"] : this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].replies[replyIndex];
    this.codeReviewService.updateCommentByCommentId(this.commentsModification[technicalDetailsId].comments[index].replies[replyIndex].editText, commentId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in Updating Comment');
      } else {
        let replyCommentModelIndex: number = this.getReplyIndexInCodeReviewComments(technicalDetailsId, this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].replies[replyIndex]);
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][replyCommentModelIndex].body = this.commentsModification[technicalDetailsId].comments[index].replies[replyIndex].editText;
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][replyCommentModelIndex].comment_history.push(data["data"]);
        this.commentsModification[technicalDetailsId].comments[index].replies[replyIndex].editText = '';
        this.commentsModification[technicalDetailsId].comments[index].replies[replyIndex].isEditing = false;
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Updating Comment');
      this.sharedService.loaderHide.emit(false);
    });
  }

  onCommentReplyDelete(technicalDetailsId, index, replyIndex) {
    this.sharedService.loaderHide.emit(true);
    let commentReplyId = this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].replies[replyIndex]["$oid"] ? this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].replies[replyIndex]["$oid"] : this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].replies[replyIndex];
    let parentCommentId = this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id["$oid"] ? this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id["$oid"] : this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id;
    this.codeReviewService.deleteCommentReplyByCommentReplyId(commentReplyId, parentCommentId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in Deleting Comment');
      } else {
        this.commentsModification[technicalDetailsId].isUpdatingDeleted = true;        
        let replyCommentModelIndex: number = this.getReplyIndexInCodeReviewComments(technicalDetailsId, this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].replies[replyIndex]);
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].replies.splice(replyIndex, 1);
        this.commentsModification[technicalDetailsId].comments[index].replies.splice(replyIndex, 1);
        this.commentsModification[technicalDetailsId].comments.splice(replyCommentModelIndex, 1);
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId].splice(replyCommentModelIndex, 1);
        this.commentsModification[technicalDetailsId].isUpdatingDeleted = false; 
        this.notifyService.notify('warning', 'Deleted', "Comment Deleted Sucessfully");
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Deleting Comment');
      this.sharedService.loaderHide.emit(false);
    });
  }

  onReplyEdit(technicalDetailsId, i, replyIndex) {
    this.commentsModification[technicalDetailsId].comments[i].replies[replyIndex].isEditing = true;
    this.commentsModification[technicalDetailsId].comments[i].replies[replyIndex].editText = this.getReply(technicalDetailsId, this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][i].replies[replyIndex]).body;
  }

  onReplySubmit(technicalDetailsId, index) {
    this.sharedService.loaderHide.emit(true);
    let commentId = this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id["$oid"] ? this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id["$oid"] : this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id;
    this.codeReviewService.addReviewCommentReplyByCommentId(this.commentsModification[technicalDetailsId].comments[index].replyText, commentId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in Adding reply Comment');
      } else {
        this.commentsModification[technicalDetailsId].comments[index].replyText = '';
        this.commentsModification[technicalDetailsId].comments[index].isReplying = false;
        this.commentsModification[technicalDetailsId].comments[index].replies.push({
          replyText: '',
          isEditing: false,
          editText: '',
          isReplying: false
        });
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId].push(data["data"]);
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index].replies.push(data["data"]._id);
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Adding Reply Comment');
      this.sharedService.loaderHide.emit(false);
    });
  }

  onReply(technicalDetailsId, i) {
    this.commentsModification[technicalDetailsId].comments[i].isReplying = true;
  }

  onReplyCancel(technicalDetailsId, i) {
    this.commentsModification[technicalDetailsId].comments[i].isReplying = false;
    this.commentsModification[technicalDetailsId].comments[i].replyText = "";
  }

  updateConversationResolution(technicalDetailsId: string, index: number,resolution: boolean) {
    this.sharedService.loaderHide.emit(true);
    let commentId = this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id["$oid"] ? this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id["$oid"] : this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]._id;
    this.codeReviewService.updateConversationResolutionByCommentId(resolution, commentId).subscribe(data => {      
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in ' + resolution?" ": "Un" + 'Resolving Comment');
      } else {
        this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId][index]= data["data"];
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in ' + resolution?" ": "Un" + 'Resolving Comment');
      this.sharedService.loaderHide.emit(false);
    });
  }

  getReply(technicalDetailsId: string, replyId: string): CodeReviewCommentModel {
    return this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId].find(comment => replyId["$oid"] ? (comment._id["$oid"] ? comment._id["$oid"] === replyId["$oid"] : comment._id === replyId["$oid"]) : (comment._id["$oid"] ? comment._id["$oid"] === replyId : comment._id === replyId));
  }

  getReplyIndexInCodeReviewComments(technicalDetailsId: string, replyId: string): number {
    return this.reviewCommentsMapByTechnicalDetailsId[technicalDetailsId].findIndex(comment => replyId["$oid"] ? (comment._id["$oid"] ? comment._id["$oid"] === replyId["$oid"] : comment._id === replyId["$oid"]) : (comment._id["$oid"] ? comment._id["$oid"] === replyId : comment._id === replyId));
  }
  
  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
  
  getObjectValues(obj: any): any[] {
    return Object.values(obj);
  }

  getFirstData(data: any): { key: string; value: any } | null {
    const keys = this.getObjectKeys(data);
    if (keys.length > 0) {
      return { key: keys[0], value: data[keys[0]] }; // Return an object with the first key and its value
    }
    return null; // Return null if no keys exist
  }
  
  toggleMapping(technicalDetailsId: string) {
    if (this.expandedMappingIds.has(technicalDetailsId)) {
      this.expandedMappingIds.delete(technicalDetailsId); // Collapse the item if it's already expanded
    } else {
      this.expandedMappingIds.add(technicalDetailsId); // Expand the item
    }
  }
  
  isExpanded(technicalDetailsId: string): boolean {
    return this.expandedMappingIds.has(technicalDetailsId); // Check if a mapping is expanded
  }

  approveCodeReview() {
    this.sharedService.loaderHide.emit(true);
    this.codeReviewService.approveCodeReviewByCodeReviewId(this.reviewId).subscribe(data => {
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in approving code review');
        this.sharedService.loaderHide.emit(false);
      } else {
        this.notifyService.notify('success', 'Success', 'Code review approved');
        this.sharedService.loaderHide.emit(false);
        // this.router.navigate([`/code-link-review/${this.reviewId}`]);
        this.router.navigate(['../'], { relativeTo: this.route });
      }
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in approving code review');
      this.sharedService.loaderHide.emit(false);
    });
  }

  requestForChanges() {
    this.sharedService.loaderHide.emit(true);
    this.codeReviewService.requestForChangesByCodeReviewId(this.reviewId).subscribe(data => {
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in requesting for changes');
        this.sharedService.loaderHide.emit(false);
      } else {
        this.notifyService.notify('success', 'Success', 'Requested for Changes');
        this.sharedService.loaderHide.emit(false);
        // this.router.navigate([`/code-link-review/${this.reviewId}`]);
        this.router.navigate(['../'], { relativeTo: this.route });
      }
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in requesting for changes');
      this.sharedService.loaderHide.emit(false);
    });
  }

  triggerParentCodeReviewModelUpdate() {
    this.codeReviewService.triggerCodeReviewModelUpdate();
  }

  toggleViewMode() {
    this.viewMode = this.viewMode === 'side-by-side' ? 'line-by-line' : 'side-by-side';
    this.sharedService.loaderHide.emit(true);
    this.loadData();
  }

  toggleView(){
    this.isVisible = !this.isVisible;
    this.viewMode = this.viewMode === 'side-by-side' ? 'line-by-line' : 'side-by-side';
    this.sharedService.loaderHide.emit(true);
    this.loadData();
  }
  showdiffView(){
    this.showDiffView = !this.showDiffView;
  }

  onDocumentClick(event: Event) {
    if (this.showDiffView) {
      this.showDiffView = false;
    }
  }

  getSections(commentBody: string) {
    // First, try to parse as JSON format
    try {
      const jsonData = JSON.parse(commentBody);
      return this.parseJsonSections(jsonData);
    } catch (e) {
      // If JSON parsing fails, use the original format
      const sections = commentBody.split('###').map(part => part.trim()).filter(part => part);
      const sectionNames = ['Issue Description', 'Severity', 'Impact', 'Recommendations'];
    
      return sections.map((content, index) => {
        const heading = sectionNames[index] || 'Unknown'; // Assign default heading for extra sections
        const cleanedContent = content.replace(new RegExp(`^${heading}:`), '').trim();
        
        return {
          heading: heading,
          content: cleanedContent // Content without the colon
        };
      });
    }
  }

  parseJsonSections(jsonData: any) {
    const sections = [];
    const sectionNames = ['Issue Description', 'Severity', 'Impact', 'Recommendations'];
    
    sectionNames.forEach(sectionName => {
      if (jsonData[sectionName]) {
        let content = '';
        
        if (sectionName === 'Severity') {
          // Handle severity specifically - extract the level value
          if (jsonData[sectionName].Level) {
            content = jsonData[sectionName].Level;
            // Validate severity level
            if (!this.validateSeverity(content)) {
              console.warn(`Invalid severity level: ${content}. Expected: High, Medium, or Low`);
              content = 'Medium'; // Default to Medium if invalid
            }
          } else if (typeof jsonData[sectionName] === 'string') {
            content = jsonData[sectionName];
            if (!this.validateSeverity(content)) {
              console.warn(`Invalid severity level: ${content}. Expected: High, Medium, or Low`);
              content = 'Medium'; // Default to Medium if invalid
            }
          } else {
            content = 'Medium'; // Default to Medium if structure is unexpected
          }
        } else if (sectionName === 'Impact') {
          // Handle impact - extract areas affected
          if (jsonData[sectionName]['Areas Affected']) {
            content = jsonData[sectionName]['Areas Affected'];
          } else {
            content = JSON.stringify(jsonData[sectionName]);
          }
        } else {
          // Handle Issue Description and Recommendations
          if (typeof jsonData[sectionName] === 'object') {
            // Convert numbered object to list format
            const items = [];
            Object.keys(jsonData[sectionName]).forEach(key => {
              if (jsonData[sectionName][key]) {
                items.push(jsonData[sectionName][key]);
              }
            });
            content = items.join('\n');
          } else {
            content = jsonData[sectionName];
          }
        }
        
        sections.push({
          heading: sectionName,
          content: content
        });
      }
    });
    
    return sections;
  }
  
  getHeadingClass(heading: string) {
    switch(heading) {
      case 'Issue Description': return 'heading-issue';
      case 'Severity': return 'heading-severity';
      case 'Impact': return 'heading-impact';
      case 'Recommendations': return 'heading-recommendations';
      default: return 'heading-default';
    }
  }
  
  getTextClass(content: string) {
    return 'content-text';
  }

  isBulletList(content: string): boolean {
    if (!content) return false;
    return /(^|\n)-\s+/.test(content);
  }

  isNumberedList(content: string): boolean {
    if (!content) return false;
    return /(^|\n)\d+\.\s+/.test(content);
  }
  
  getSeverityClass(severity: string) {
    if (severity.toLowerCase() === 'high') {
      return 'severity-high';
    } else if (severity.toLowerCase() === 'medium') {
      return 'severity-medium';
    } else if (severity.toLowerCase() === 'low') {
      return 'severity-low';
    }
    return ''; // In case severity is not provided or is unrecognized
  }

  validateSeverity(severity: string): boolean {
    const validSeverities = ['high', 'medium', 'low'];
    return validSeverities.includes(severity.toLowerCase());
  }
  
  transform(value: string): string[] {
    // Split based on "n. **" and ensure we keep points clean
    return value.split(/(?=\d+\.\s\*\*)/).map(item => item.trim());
  }

  getRecommendations(content: string): string[] {
    // Remove bold syntax (**bold text**) and preserve the numbered list
    const cleanContent = content.replace(/\*\*(.*?)\*\*/g, '$1');
    
    // Split content by bullet points or line breaks to get each recommendation
    const recommendationRegex = /\d+\.\s([^\n]+)/g;
    const recommendations = [];
    let match;
    
    // Find all the recommendations in the content
    while ((match = recommendationRegex.exec(cleanContent)) !== null) {
      recommendations.push(match[1].trim()); // Extract the recommendation text and trim it
    }
    
    return recommendations;
  }

  getListItems(content: string): string[] {
    // Step 1: Remove bold syntax (**bold text**) from the content AFTER processing the list
    let cleanContent = content.replace(/\*\*(.*?)\*\*/g, '$1'); // This removes ** and keeps the word itself
    
    // Step 2: Handle numbered lists like "1. ", "2. ", etc.
    const numberedListItems = [];
    const numberedListRegex = /\d+\.\s([^\n]+)/g;
    let match;
    while ((match = numberedListRegex.exec(cleanContent)) !== null) {
      numberedListItems.push(match[1].trim());
    }
  
    // Step 3: Handle bullet points with "- " and convert them to numbered list style
    const bulletListItems = [];
    const bulletListRegex = /-\s([^\n]+)/g;
    let bulletMatch;
    while ((bulletMatch = bulletListRegex.exec(cleanContent)) !== null) {
      bulletListItems.push(bulletMatch[1].trim());
    }

    // Step 4: Handle newline-separated items (from JSON format)
    const newlineItems = [];
    if (cleanContent.includes('\n') && numberedListItems.length === 0 && bulletListItems.length === 0) {
      const lines = cleanContent.split('\n').filter(line => line.trim());
      newlineItems.push(...lines);
    }
  
    // Step 5: Combine all items into one list
    const allItems = [...numberedListItems, ...bulletListItems, ...newlineItems];
    
    // Step 6: Remove any dynamically bolded word (like **High**, **Low**) after processing the list
    const filteredItems = allItems.map(item => {
      // Here we remove ** from any word in the list, e.g., **High** -> High
      return item.replace(/\*\*(.*?)\*\*/g, '$1').trim(); // Remove bold formatting
    });
  
    return filteredItems;
  } 
  
}
